export default "__VITE_ASSET__BzjhqxM1__"